// Collapsible raw-payload viewer for the B2B prospect detail page.
// Verbose JSON is collapsed by default and revealed on demand; supports
// copy-to-clipboard with a fallback for browsers without the async API.
document.addEventListener('alpine:init', () => {
  Alpine.data('raw_payload_viewer', () => ({
    open: false,
    copied: false,
    copyError: false,

    toggle() {
      this.open = !this.open;
    },

    async copy() {
      const text = this.$refs.payload ? this.$refs.payload.textContent : '';
      try {
        await navigator.clipboard.writeText(text);
        this.flagCopied();
      } catch (e) {
        this.fallbackCopy(text);
      }
    },

    flagCopied() {
      this.copied = true;
      setTimeout(() => { this.copied = false; }, 1000);
    },

    fallbackCopy(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand('copy');
        this.flagCopied();
      } catch (e) {
        this.copyError = true;
        setTimeout(() => { this.copyError = false; }, 3000);
      }

      document.body.removeChild(textArea);
    }
  }));
});
